Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
const shared = require("@volar/shared");
const symbolInformation_1 = require("./symbolInformation");
function transform(locations, getOtherLocation) {
    return locations
        .map(location => (0, symbolInformation_1.transform)(location, getOtherLocation))
        .filter(shared.notEmpty);
}
exports.transform = transform;
//# sourceMappingURL=symbolInformations.js.map